import gql from 'graphql-tag'

import { ResetPasswordMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation resetPassword(
      $email: String!
      $password: String!
      $password_confirmation: String!
      $token: String!
    ) {
      rdvResetPassword(
        email: $email
        password: $password
        password_confirmation: $password_confirmation
        token: $token
      )
    }
  `,
  transformer: (response: ResetPasswordMutation) => {
    return response
  },
}
